exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-avatar {\n    height: 42px;\n    width: 42px;\n    background: #7ed321;\n    border-radius: 50%;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 300;\n    color: #ffffff;\n}\n\n.client-avatar span {\n    position: relative;\n    top: 20px;\n}\n\n.client-avatar p {\n padding: 9px 1px;\n font-size: 20px;\n height: 42px;\n}\n", ""]);

// exports
